"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

// Mirror of:  https://git.hubteam.com/HubSpot/content4j/blob/master/ContentModel/src/main/java/com/hubspot/content/model/EmailType.java
var _default = Object.freeze((0, _keyMirror.default)({
  BATCH_EMAIL: null,
  AB_EMAIL: null,
  AUTOMATED_EMAIL: null,
  BLOG_EMAIL: null,
  BLOG_EMAIL_CHILD: null,
  FOLLOWUP_EMAIL: null,
  LOCALTIME_EMAIL: null,
  OPTIN_EMAIL: null,
  OPTIN_FOLLOWUP_EMAIL: null,
  RESUBSCRIBE_EMAIL: null,
  RSS_EMAIL: null,
  RSS_EMAIL_CHILD: null,
  SINGLE_SEND_API: null,
  LEADFLOW_EMAIL: null,
  FEEDBACK_NPS_EMAIL: null,
  FEEDBACK_CES_EMAIL: null,
  FEEDBACK_CUSTOM_EMAIL: null,
  TICKET_EMAIL: null,
  SMTP_TOKEN: null
}));

exports.default = _default;
module.exports = exports.default;